
import { defineComponent, PropType } from 'vue'
import CookiesCoreMixinVue from '@/modules/CookiesCoreMixin.vue'

export default defineComponent({
  mixins: [CookiesCoreMixinVue],
  props: {
    DialogIndex: Number,
    DialogData: { default: () => { return {} }, type: Object as PropType<DialogData> }
  },
  data () {
    return {
      OriginalData: {} as any,
      Saving: false,
      Loading: [],
      ErrorsVisibilty: false,
      DialogMapper: [
        { Path: 'Name', Res: 'D_Employee_Name' },
        { Path: 'PhoneNumber', Res: 'D_Employee_PhoneNumber' },
        { Path: 'Email', Res: 'D_Employee_Email' },
        { Path: 'Type', Res: 'D_Employee_Type' },
        { Path: 'Salary', Res: 'D_Employee_Salary' },
        { Path: 'Status', Res: 'D_Employee_Status' },
        { Path: 'CanLogIn', Res: 'D_Employee_CanLogin' },
        { Path: 'PasswordHash', Res: 'D_Employee_Password' },
        { Path: 'ImgUrl', Res: 'D_Employee_Image', IsImage: true }
      ] as Array<DialogMapperObject>
    }
  },
  methods: {
    SaveData () {
      this.SaveDialogData({
        DialogMapper: this.DialogMapper,
        Parentthis: this,
        PostAPI: 'HR_Employees',
        OriginalData: this.OriginalData,
        PatchAPI: 'HR_Employees',
        Editing: this.DialogData.Editing
      })
    },
    DataSaved () {
      this.Saving = false
      this.$router.go(-1)
    },
    ChangePassword () {
      this.OpenDialog('Security_ChangePassword_Dialog', 'Change Password', this.MEMRead('D_Employee_Email')) // [ Dialog Component Name, Dialog Header Text, Dialog Data tot pass ]
    }
  },
  mounted () {
    const Dialog = document.getElementById('CookiesDialog_' + this.DialogIndex)
    if (Dialog) {
      window.scrollTo(0, Dialog.offsetTop - 60)
    }
    if (this.DialogData.Editing) {
      this.OriginalData = this.CookiesDialogInitiator(this.DialogMapper, this.DialogData.Data)
      this.Console(this.OriginalData)
    }
  },
  computed: {}
})
